var exports = {
  "kL": "MessageUploadProgress.module__container___bk1kQU",
  "zc": "MessageUploadProgress.module__iconContainer___bk1kQU",
  "Qs": "MessageUploadProgress.module__content___bk1kQU",
  "Md": "MessageUploadProgress.module__fileName___bk1kQU",
  "Ov": "MessageUploadProgress.module__fileSize___bk1kQU",
  "L$": "MessageUploadProgress.module__progressContainer___bk1kQU",
  "Ik": "MessageUploadProgress.module__progressBarIndeterminate___bk1kQU",
  "hr": "MessageUploadProgress.module__progressBar___bk1kQU",
  "E$": "MessageUploadProgress.module__progressBarNormal___bk1kQU",
  "cs": "MessageUploadProgress.module__progressBarFailed___bk1kQU",
  "x7": "MessageUploadProgress.module__cancelButton___bk1kQU",
};

module.exports = exports;
